import React from 'react';
import { Box, Typography } from '@mui/material';
import { TrendingUp, Business, LocationOn } from '@mui/icons-material';

interface ClientStatisticsProps {
  currentClient?: {
    totalEmissions: number;
    organizations: number;
    locationsCount: number;
  };
}

const ClientStatistics: React.FC<ClientStatisticsProps> = ({ currentClient }) => {
  return (
    <Box data-testid="client-statistics"
      sx={{
        display: 'flex',
        p: 1,
        pl: 2,
        mb: 2,
        bgcolor: 'white',
        borderRadius: 0,
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1 }}>
        <Box
          sx={{
            width: 26,
            height: 26,
            borderRadius: 1,
            bgcolor: '#e3f2fd',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <TrendingUp sx={{ color: '#2196f3', fontSize: 20 }} />
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary" >
            Total Emissions
          </Typography>&nbsp;
          <Typography variant="caption" fontWeight={600}>
            {currentClient?.totalEmissions.toLocaleString()} tCO₂e
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1 }}>
        <Box
          sx={{
            width: 26,
            height: 26,
            borderRadius: 1,
            bgcolor: '#e8f5e9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Business sx={{ color: '#4caf50', fontSize: 20 }} />
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary" sx={{ mb: 0.25 }}>
            Organizations
          </Typography>&nbsp;
          <Typography variant="caption" fontWeight={600}>
            {currentClient?.organizations}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1 }}>
        <Box
          sx={{
            width: 26,
            height: 26,
            borderRadius: 1,
            bgcolor: '#f3e5f5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <LocationOn sx={{ color: '#9c27b0', fontSize: 20 }} />
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary" sx={{ mb: 0.25 }}>
            Locations
          </Typography>&nbsp;
          <Typography variant="caption" fontWeight={600}>
            {currentClient?.locationsCount}
          </Typography>
        </Box>
      </Box>


     
    </Box>
  );
};

export default ClientStatistics;
